import {
  PrimaryTextColor,
  boldFont,
  centerItemFlex,
  getRelativeFontSize,
  mediumFont,
  normalFont,
  primaryBlueColor,
  regularFont,
} from "../../../../utils/styles";
import BackgroundImg from "../../../../assets/images/bg-pattern-1.svg";

const ForgotPasswordStyles = {
  mainContentWrapper: {
    backgroundImage: `url(${BackgroundImg})`,
    backgroundRepeat: " no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: "100vh",
    width: "100%",
  },
  contentWrapper: {
    width: "100%",
    height: "100vh",
    ...centerItemFlex,
    flexDirection: "column",
  },
  cardHeader: {
    padding: "46px 23px 0px 23px",
  },
  disclamer: {
    color: "#9E9FAB",
    ...regularFont,
    fontSize: "14px",
  },
  cardTitle: {
    fontSize: getRelativeFontSize(10),
    ...boldFont,
    color: PrimaryTextColor,
  },
  cardSubText: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
    color: PrimaryTextColor,
  },
  cardContent: {
    padding: "0px 23px",
    marginTop: 3,
  },
  cardFooter: {
    padding: "0px 23px",
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: 3,
  },
  signUpStyle: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },
  backToLogin: {
    color: primaryBlueColor,
    cursor: "pointer",
    ...mediumFont,
    fontSize: "16px",
    marginLeft: "13px",
  },
};

export default ForgotPasswordStyles;
